import { Component,Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { ChartDefinition } from 'src/shared/models/chart-definintions.model';
import { ReportService } from 'src/shared/services/report.service';
import { Observable, Subscription, from } from 'rxjs';
import { ReportData } from 'src/shared/models/report-data.model';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import * as moment from 'moment';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'smt-dailychurnratereport',
  templateUrl: './daily-churn-rate-report.component.html',
  styleUrls: ['./daily-churn-rate-report.component.scss']
})
export class DailyChurnRateReportComponent implements OnInit {
  churnData: ReportData;
  chartDefinition: ChartDefinition = new ChartDefinition();
  dailyChurnRateChart : Chart;
  loading:boolean;
  reportSubscription : Subscription;
  
  private expandEventsSubscription: Subscription;
  private filterEventSubscription: Subscription;
  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters:ReportFilters;

  @Output() dataUpdated = new EventEmitter();

  constructor(private _reportService:ReportService) { }

  ngOnInit() {
    this.drawEmpty();
    this.loading = true;
    if(this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.getData());
  }

  drawEmpty()
  {
    this.dailyChurnRateChart = this.chartDefinition.getColumnTemplate(
      'Churn Rate',
      '' ,
      'Churn Rate',
      [] ,
      true
    );
  }

  drawGrid()
  {
    this.loading = false;
    const minRows:number = 2;

    if (!this.churnData)
      return;

    let chartData = MiscUtil.getDataFilteredByDataSetName(this.churnData);

    this.dailyChurnRateChart = this.chartDefinition.getColumnTemplate(
      this.getTitle(),
      this.reportFilters.ReportView,
      'Churn Rate',
      this.churnData.xAxis ,
      true
    );

    if (chartData.length == 0)
      return;

    let chartSizeMinusOne = chartData.length - 1;

    // Add all but the last entry with the re-draw flag set to false this speeds up chart drawing
    chartData.slice(0,chartSizeMinusOne).forEach(dataSet =>
      {
        this.dailyChurnRateChart.addSeries({type: 'line', name: dataSet.name, 	data:  dataSet.data},false,true);
      });

    this.dailyChurnRateChart.addSeries({type: 'line', name: chartData[chartSizeMinusOne].name, 	data:  chartData[chartSizeMinusOne].data},true,true);
  }

  getTitle()
  {
    var title = 'Churn Rate'; 
    if(this.reportFilters.ReportView) {
      title = `Churn Rate by ${this.reportFilters.ReportView}`;
    }
    return title;
  }

  async getData()
  {

    this.loading = true;

    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this._reportService.getDailyChurnReport(this.reportFilters))
                                                      .subscribe(x =>
                                                      {
                                                        this.churnData = x ;
                                                        this.dataUpdated.emit(this.churnData);
                                                        this.drawGrid();
                                                      });
  }

  ngOnDestroy() {
    if(this.filtersUpdated)
      this.filterEventSubscription.unsubscribe();
    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();
}


}
